import React, { useRef, useState, useEffect } from "react";
import Tooltip from "@mui/material/Tooltip";
import { useResizeDetector } from "react-resize-detector";
import { useDebounce } from "use-debounce";

export default function PTMTooltipEllipsis(props) {
    const {
        children, style, onClick, disabled,
    } = props;

    const textElementRef = useRef();
    const { width, ref } = useResizeDetector();
    const [debouncedWidth] = useDebounce(width, 250);

    const [open, setOpen] = useState(false);
    const [isOverflowed, setIsOverflow] = useState(false);

    useEffect(() => {
        setIsOverflow(textElementRef.current.scrollWidth > textElementRef.current.clientWidth);
    }, [debouncedWidth, textElementRef]);

    return (
        <Tooltip
            ref={ref}
            open={open && isOverflowed}
            disabled={disabled}
            onMouseEnter={() => !disabled && setOpen(true)}
            onMouseLeave={() => !disabled && setOpen(false)}
            sx={{ pointerEvents: "none" }}
            title={children !== null ? children : ""}
            disableHoverListener={!isOverflowed || disabled}
            disableInteractive
            disableFocusListener
            followCursor
        >
            {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */}
            <div
                ref={textElementRef}
                style={{
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    ...style,
                }}
                onClick={onClick}
            >
                {children}
            </div>
        </Tooltip>
    );
}
